import { useTranslation } from "react-i18next";
import { HostLocationSelection } from "./HostLocationSelection";

export const VirtualEvent = () => {
  const { t } = useTranslation("events", {
    keyPrefix: "APP.MODAL.EVENT_HOST.LOCATION_SELECTION",
  });

  const formFieldRoot = "eventLocation";

  return (
    <HostLocationSelection
      index={0}
      formFieldRoot={formFieldRoot}
      eventLinkControlledInputProps={{
        name: `${formFieldRoot}.contact.links.website`,
        label: t("BUSINESS_WEBSITE"),
        hint: t("EVENT_LINK_HINT_VIRTUAL"),
      }}
      emailControlledInputProps={{
        name: `${formFieldRoot}.contact.email`,
        label: t("EMAIL"),
      }}
      phoneControlledInputProps={{
        name: `${formFieldRoot}.contact.phone`,
        label: t("PHONE"),
      }}
    />
  );
};
